export const NAME_CREATORS = {
  COMMENT: 'comment',
  ITEM: 'item',
  ORGANIZATION: 'org',
  STREAM: 'stream',
  CHANNEL: 'channel',
  SUBSCRIPTION: 'subscription',
  SUPPORT: 'support',
  ROLES_PACKAGE: 'rolesPackage',
  RSS_FEED: 'rssFeed',
};
